if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.stickyBar = null;
      this.originalButtons = null;
      this.observer = null;
      this.isVisible = false;
      this.quantityInput = null;
      this.mainQuantityInput = null;
      this.quantityButtons = null;
      this.submitButton = null;
      
      this.init();
    }

    init() {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      this.stickyBar = this;

      const productForm = document.querySelector(`#product-form-${sectionId}`);
      if (productForm) {
        this.originalButtons = productForm.querySelector('.product-form__buttons');
      }

      if (!this.originalButtons) return;

      this.quantityInput = this.stickyBar.querySelector('[data-sticky-quantity="input"]');
      this.mainQuantityInput = productForm.querySelector('#Quantity-' + sectionId);
      this.quantityButtons = this.stickyBar.querySelectorAll('[data-sticky-quantity]');
      this.submitButton = this.stickyBar.querySelector('[data-sticky-atc-submit]');

      this.stickyBar.style.display = 'block';

      this.syncQuantity();

      this.setupQuantityHandlers();

      this.setupViewportObserver();

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });

      this.checkVisibility();
    }

    syncQuantity() {
      if (!this.mainQuantityInput || !this.quantityInput) return;

      const mainValue = this.mainQuantityInput.value;
      this.quantityInput.value = mainValue;

      this.mainQuantityInput.addEventListener('input', () => {
        this.quantityInput.value = this.mainQuantityInput.value;
      });
    }

    setupQuantityHandlers() {
      if (!this.quantityButtons || !this.mainQuantityInput || !this.quantityInput) return;
      
      this.quantityInput.addEventListener('input', () => {
        if (this.mainQuantityInput) {
          this.mainQuantityInput.value = this.quantityInput.value;
          this.mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      this.quantityInput.addEventListener('change', () => {
        if (this.mainQuantityInput) {
          this.mainQuantityInput.value = this.quantityInput.value;
          this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    setQuantity(value) {
      if (this.quantityInput) {
        this.quantityInput.value = value;
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.mainQuantityInput) {
        this.mainQuantityInput.value = value;
        this.mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    setupViewportObserver() {
      if (!this.originalButtons || !('IntersectionObserver' in window)) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              this.show();
            } else {
              this.hide();
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0
        }
      );

      this.observer.observe(this.originalButtons);
    }

    handleScroll() {
      if (this.scrollTimeout) {
        return;
      }

      this.scrollTimeout = setTimeout(() => {
        this.checkVisibility();
        this.scrollTimeout = null;
      }, 100);
    }

    checkVisibility() {
      if (!this.originalButtons) return;

      const rect = this.originalButtons.getBoundingClientRect();
      const isAboveViewport = rect.bottom < 0;
      const isBelowViewport = rect.top > window.innerHeight;
      const isNotVisible = isAboveViewport || isBelowViewport;

      if (isNotVisible) {
        this.show();
      } else {
        this.hide();
      }
    }

    show() {
      if (this.isVisible || !this.stickyBar) return;
      
      this.isVisible = true;
      this.stickyBar.classList.add('sticky-atc-bar--visible');
      document.body.classList.add('sticky-atc-active');
    }

    hide() {
      if (!this.isVisible || !this.stickyBar) return;
      
      this.isVisible = false;
      this.stickyBar.classList.remove('sticky-atc-bar--visible');
      document.body.classList.remove('sticky-atc-active');
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  });
}


